import {responsiveLayout, componentScroll} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ResponsivePublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ResponsivePublicAPI> {
    const {
        extensionPublicAPI: {getter}
    } = publicMethodUtils

    return {
        // @ts-expect-error BUG: initMethod is not defined in responsiveLayout
        initMethod: responsiveLayout.init,
        methods: {
            components: {
                scroll: {
                    onComponentsScroll: publicMethodUtils.defineAction(componentScroll.onComponentsScroll)
                },
                responsiveLayout: {
                    update: publicMethodUtils.defineDataManipulationAction(responsiveLayout.update),
                    get: publicMethodUtils.defineGetter(responsiveLayout.get),
                    measure: publicMethodUtils.defineGetter(responsiveLayout.measure),
                    isNewLayoutMigration: publicMethodUtils.defineGetter(responsiveLayout.isNewLayoutMigration),
                    pin: publicMethodUtils.defineDataManipulationAction(responsiveLayout.pin),
                    unpin: publicMethodUtils.defineDataManipulationAction(responsiveLayout.unpin),
                    scoped: {
                        remove: publicMethodUtils.defineDataManipulationAction(responsiveLayout.removeScopedLayout)
                    },
                    getRuntimeProperty: publicMethodUtils.defineGetter(responsiveLayout.getRuntimeProperty)
                }
            },
            responsiveLayout: {
                generators: {
                    autoGrid: {
                        generate: getter('layout.generators.autoGrid.generate')
                    }
                },
                update: publicMethodUtils.defineDataManipulationAction(responsiveLayout.update),
                get: publicMethodUtils.defineGetter(responsiveLayout.get),
                measure: publicMethodUtils.defineGetter(responsiveLayout.measure),
                isNewLayoutMigration: publicMethodUtils.defineGetter(responsiveLayout.isNewLayoutMigration),
                pin: publicMethodUtils.defineDataManipulationAction(responsiveLayout.pin),
                unpin: publicMethodUtils.defineDataManipulationAction(responsiveLayout.unpin),
                runtime: {
                    measure: {
                        getBoundingBox: publicMethodUtils.defineGetter(responsiveLayout.getBoundingBox),
                        getContainerBoundingBoxes: publicMethodUtils.defineGetter(
                            responsiveLayout.getContainerBoundingBoxes
                        ),
                        getNonRotatedBoundingBox: publicMethodUtils.defineGetter(
                            responsiveLayout.getNonRotatedBoundingBox
                        ),
                        getRelativeToViewportBoundingBox: publicMethodUtils.defineGetter(
                            responsiveLayout.getRelativeToViewportBoundingBox
                        ),
                        getPadding: publicMethodUtils.defineGetter(responsiveLayout.getPadding),
                        getScrollHeight: publicMethodUtils.defineGetter(responsiveLayout.getScrollHeight),
                        getClientHeight: publicMethodUtils.defineGetter(responsiveLayout.getClientHeight),
                        getScrollWidth: publicMethodUtils.defineGetter(responsiveLayout.getScrollWidth),
                        getScrollBarWidth: publicMethodUtils.defineGetter(responsiveLayout.getScrollBarWidth),
                        getClientWidth: publicMethodUtils.defineGetter(responsiveLayout.getClientWidth),
                        getGridMeasures: publicMethodUtils.defineGetter(responsiveLayout.getGridMeasures)
                    },
                    // new APIs
                    detachComponents: publicMethodUtils.defineAction(responsiveLayout.detachComponents),
                    reattachComponents: publicMethodUtils.defineAction(responsiveLayout.reattachComponents),
                    //
                    detachLayout: publicMethodUtils.defineAction(responsiveLayout.detachLayout),
                    detachContainer: publicMethodUtils.defineAction(responsiveLayout.detachContainer),
                    updateDetachedLayout: publicMethodUtils.defineAction(responsiveLayout.updateDetachedLayout),
                    updateDetachedStyles: publicMethodUtils.defineAction(responsiveLayout.updateDetachedStyles),
                    updateDetachedRotation: publicMethodUtils.defineAction(responsiveLayout.updateDetachedRotation),
                    updateDetachedTransformation: publicMethodUtils.defineAction(
                        responsiveLayout.updateDetachedTransformation
                    ),
                    updateGridCssOverrides: publicMethodUtils.defineAction(responsiveLayout.updateGridCssOverrides),
                    updatePaddingCssOverrides: publicMethodUtils.defineAction(
                        responsiveLayout.updatePaddingCssOverrides
                    ),
                    clearCompCssOverrides: publicMethodUtils.defineAction(responsiveLayout.clearCompCssOverrides),
                    reattachLayout: publicMethodUtils.defineAction(responsiveLayout.reattachLayout),
                    gridItem: {
                        detach: publicMethodUtils.defineAction(responsiveLayout.detachGridItem),
                        updateDetached: publicMethodUtils.defineAction(responsiveLayout.updateDetachedGridItem),
                        reattach: publicMethodUtils.defineAction(responsiveLayout.reattachGridItem)
                    },
                    stackItem: {
                        detach: publicMethodUtils.defineAction(responsiveLayout.detachStackItem),
                        updateDetached: publicMethodUtils.defineAction(responsiveLayout.updateDetachedStackItem),
                        updateDetachedOrder: publicMethodUtils.defineAction(
                            responsiveLayout.updateDetachedStackItemOrder
                        ),
                        reattach: publicMethodUtils.defineAction(responsiveLayout.reattachStackItem)
                    },
                    registerToMeasurementsChange: publicMethodUtils.extensionPublicAPI.immediate(
                        'viewer.measurements.registerToMeasurementsChange'
                    ),
                    getAllMeasurements: publicMethodUtils.extensionPublicAPI.getter('viewer.measurements.getAll')
                }
            },
            site: {
                isWithStaticSharedPartsInflation: publicMethodUtils.extensionPublicAPI.getter(
                    'site.isWithStaticSharedPartsInflation'
                )
            }
        }
    }
}
